import React from "react";
import { useTranslation } from "react-i18next";
import LanguageSelector from './LanguageSelector';

function Contact() {
  const { t } = useTranslation();
  return (
    <div>
      <div className="row banner" style={{backgroundImage:'url(./images/thali.jpeg)',backgroundSize:'cover',backgroundPosition:'top'}}></div>
      <div className="container" style={{marginTop:'100px',marginBottom:'100px'}}>
       
        <div className="row">
            <div className="col-md-5" style={{background:'#ffffffff',padding:'50px'}}>
               <div className="row" style={{borderBottom:'0px solid orange',paddingBottom:'15px',paddingTop:'15px'}}>
                    <h3 className="cheading" >Address</h3>
                    {/* first */}
                    <div class="row" style={{borderBottom:'1px solid orange',paddingBottom:'15px',marginBottom:'15px',width:'100%'}}>
                        <div className="col-md-1 middle">
                          <i class="fa fa-map-marker contacticons" aria-hidden="true"></i>
                        </div>
                        <div className="col-md-10 ">
                            <p className="addr">Tali Shiva Kshethram <br /> Zamorin Raja Devasom <br />
(Under Malabar Devaswom Board) <br /> Chalappuram(PO), Kozhikode, <br />
										Kerala 673002</p>                                               
                        </div>
                    </div>
                    <div class="row" style={{borderBottom:'1px solid orange',paddingBottom:'15px',marginBottom:'15px',width:'100%'}}>
                        <div className="col-md-1 middle">
                          <i class="fa fa-phone-square contacticons" aria-hidden="true"></i>
                        </div>
                        <div className="col-md-10 ">
                            <p className="addr">04952703610</p>                                               
                        </div>
                    </div>
                    <div class="row" style={{borderBottom:'1px solid orange',paddingBottom:'15px',marginBottom:'15px',width:'100%'}}>
                        <div className="col-md-1 middle">
                          <i class="fa fa-envelope contacticons" aria-hidden="true"></i>
                        </div>
                        <div className="col-md-10 ">
                            <p className="addr">talitempleclt@gmail.com</p>                                               
                        </div>
                    </div>
                    
                </div>
           </div>
           
           <div className="col-md-7" style={{backgroundSize:'cover',backgroundPosition:'center'}}>
            {/* <p style={{fontFamily:'manjari',fontSize:'12pt',fontWeight:'700',lineHeight:'20pt'}}>
              പെരളശ്ശേരി ശ്രീ സുബ്രഹ്മണ്യസ്വാമി ക്ഷേത്രത്തിൽ നിന്നും അഞ്ചു കിലോമീറ്റർ ദൂരം
            </p> */}
             <iframe
        title="Google Map"
        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d8014204.726965426!2d75.78761200000001!3d11.247731!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba65941d72de8df%3A0x6390e4e6ab306f85!2sTali%20Maha%20Shiva%20Kshetram!5e0!3m2!1sen!2sin!4v1783411524662!5m2!1sen!2sin"
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
      ></iframe>

             
       
           </div>           
        </div>
        
        
      </div>
    </div>
  );
}

export default Contact;

